export default __webpack_public_path__ + "static/media/a008-1.15517105.svg";